import { Navbar } from "../navbar";
import { CartellaButtons } from "../cartella-buttons";
import { ContentController } from "../contentController";
import { SummaryContentFooter } from "../summaryContentFooter";
import { BreadCrumb } from "../breadcrumb";
import { useBucketContext } from "context/bucket";
import { FileDropzone } from "../fileDropzone";
import { useAppSelector } from "redux/store";
import { selectLogin } from "redux/selectors";
import { LogoutPage } from "components/logoutPage";

export const HomeLayout = () => {
  
  const { showLogoutPage } = useAppSelector(selectLogin);
  const { breadcrumb } = useBucketContext();

  return (
    <>
      {showLogoutPage ? (
        <LogoutPage />
      ) : (
        <>
          <Navbar />
          <div
            className="container-fluid mt-4 d-flex flex-column flex-grow-1 gap-3"
            style={{ maxWidth: 900 }}
          >
            <div className="row align-items-md-center justify-content-md-between px-0 flex-column flex-md-row">
              <div className="col-6 order-2 order-md-1">
                {breadcrumb && <BreadCrumb breadcrumb={breadcrumb} />}
              </div>
              <div className="col-6 order-1 order-md-2">
                <CartellaButtons />
              </div>
            </div>
            <div className="flex-grow-1">
              <FileDropzone>
                <ContentController />
              </FileDropzone>
            </div>
          </div>
          <div className="mt-auto shadow-lg">
            <SummaryContentFooter />
          </div>
        </>
      )}
    </>
  );
};
